export default __webpack_public_path__ + "images/c162762bd0679b69128a1bc5fde9d4d3.svg";